import axios from '@/utils/axios';

export default {
  getCollections() {
    return axios.get('/collection',);
  },

  createCollection(data) {
    return axios.post('/collection', data);
  },
};
